// Entry point for the build script in your package.json
// Turbo explicitly disabled
// import "@hotwired/turbo-rails"
import "./controllers"

// NOTE: jQuery is now loaded via CDN in the application layout

// Import Bootstrap
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Import jQuery plugins for non-carousel functionality
import "jquery.easing";

// Import WOW.js
import WOW from "wow.js";
window.WOW = WOW;

// Import CounterUp dependencies
import "waypoints/lib/jquery.waypoints";
import counterUp from "counterup2";
window.counterUp = { default: counterUp };

// NOTE: Owl Carousel is now loaded via CDN in the application layout

// Initialize the app when DOM is loaded
document.addEventListener("DOMContentLoaded", function() {
  // Initialize tooltips
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  const tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Initialize WOW.js
  new WOW().init();

  // Spinner
  setTimeout(function() {
    if ($('#spinner').length > 0) {
      $('#spinner').removeClass('show');
    }
  }, 1);

  // Sticky Navbar
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      $('.sticky-top').addClass('shadow-sm').css('top', '0px');
    } else {
      $('.sticky-top').removeClass('shadow-sm').css('top', '-100px');
    }
  });

  // Back to top button
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      $('.back-to-top').fadeIn('slow');
    } else {
      $('.back-to-top').fadeOut('slow');
    }
  });

  $('.back-to-top').click(function() {
    $('html, body').animate({scrollTop: 0}, 1500, 'easeInOutExpo');
    return false;
  });

  // Facts counter
  const counterUp = window.counterUp["default"];
  const $counters = $('[data-toggle="counter-up"]');

  $counters.each(function(ignore, counter) {
    const waypoint = new Waypoint({
      element: counter,
      handler: function() {
        counterUp(counter, {
          duration: 2000,
          delay: 10
        });
        this.destroy();
      },
      offset: 'bottom-in-view',
    });
  });

  // Note: Testimonials carousel is initialized in carousel_init.js
});
